"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretUp = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CaretUp = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M17.793 14.515a.7.7 0 010 .994l-.28.28a.686.686 0 01-.504.21H6.991a.686.686 0 01-.504-.21l-.28-.28a.7.7 0 010-.994l5.303-5.303a.672.672 0 01.98 0l5.303 5.303z" })); };
exports.CaretUp = CaretUp;
//# sourceMappingURL=caret-up.js.map